import { styled, useTheme } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import darkSyntax from './syntax-dark.css?url';
import lightSyntax from './syntax-light.css?url';

const ScrollContainer = styled('div')(() => ({
  overflowX: 'auto',
  maxWidth: '100%',
}));

export const SyntaxHighlight = ({
  children,
}: { children: React.ReactNode }) => {
  const theme = useTheme();

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          href={theme.themeName === 'dark' ? darkSyntax : lightSyntax}
        />
      </Helmet>
      <ScrollContainer>{children}</ScrollContainer>
    </>
  );
};
